import React, { useState, useEffect, useContext } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

import ButtonBurger from "../../atoms/button-burger/buttonBurger";
import FontSize from "../../atoms/font-size/fontSize";
import Login from "../../atoms/login/login";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useScrollDetect from "../../../shared/hooks/useScrollDetect";

import "./header.scss";
import GlobalContext from "../../../contexts/globalContext";

interface HeaderInterface {
  isDark: boolean;
  isMenuActive: boolean;
  isSearcherActive: boolean;
  isNotRoot?: boolean;
  lastDirection: number;
  hideHeaderDesktop: boolean;
  hideHeaderMobile: boolean;
  scrollActive: { get: boolean; set: (_var: boolean) => void };
  setMenuActive: (isMenuActive: boolean) => void;
  setSearcherActive: (isSearcherActive: boolean) => void;
  actionTheme: () => void;
}

const Header = (props: HeaderInterface) => {
    const { gigyaContext: { gigyaAccount, login, logout, updateProfile  } } = useContext(GlobalContext);
  const [showFontSize, setShowFontSize] = useState(false);
  const { refElement, isScrollActive } = useScrollDetect();
  const { document, isBrowser, window } = useBrowserMode();
  
  useEffect(() => {
    props.scrollActive.set(isScrollActive);
  }, [isScrollActive]);

  const data = useStaticQuery(graphql`
    query HEADER_CONTENT {
      allContentfulMenuLoggin(
        filter: { titulo: { eq: "Menu login bibliotecas" } }
      ) {
        nodes {
          inicioSesion
          logoGray {
            title
            file {
              url
              fileName
            }
          }
          logoMagenta {
            title
            file {
              url
              fileName
            }
          }
          logoWithe {
            title
            file {
              url
              fileName
            }
          }
        }
      }
    }
  `);

  const {
    inicioSesion,
    logoGray,
    logoMagenta,
    logoWithe,
  } = data.allContentfulMenuLoggin.nodes[0];

  
  const isModeOpen =
    props.isMenuActive ||
    props.isSearcherActive 
    ||
    props.isNotRoot

  const modeShadow =
    (isBrowser &&
      window.screen.width < 960 &&
      !props.isNotRoot &&
      props.isMenuActive &&
      !props.isSearcherActive) ||
    (isScrollActive && !props.isMenuActive && !props.isSearcherActive) 
    ||
    props.isNotRoot;

  const openMenu = () => {
    toogleFreeze(true);
    props.setMenuActive(true);
    props.setSearcherActive(false);
  };
  const closeMenu = () => {
    toogleFreeze(false);
    props.setMenuActive(false);
  };

  const handleSearcher = () => {
    toogleFreeze(!props.isSearcherActive);
    props.setSearcherActive(!props.isSearcherActive);
    props.isMenuActive && props.setMenuActive(false);
  };

  const toogleFreeze = (isToggle: boolean) => {    
    isToggle
      ? document.body.classList.add("freeze-page")
      : document.body.classList.remove("freeze-page");
  };


  const renderBurguerButton = () => {
    const burguerButton = (
      <ButtonBurger
        isMenuActive={props.isMenuActive}
        isSearcherActive={props.isSearcherActive}
        closeMenu={closeMenu}
        openMenu={openMenu}
        isNotRoot={isModeOpen || modeShadow}
        lastDirection={props.lastDirection}
        hideHeaderDesktop={props.hideHeaderDesktop}
      />
    );

    if (isBrowser && window.screen.width < 960 && props.isSearcherActive)
      return <React.Fragment />;

    return burguerButton;
  };

  const renderLoginButton = () => {
    const loginButton = (
      <Login
        isMenuActive={isModeOpen}
        title={inicioSesion}
        login={login}
        logout={logout}
        updateProfile={updateProfile}
        gigyaAccount={gigyaAccount}
      />
    );

    if (isBrowser && window.screen.width < 960 && props.isSearcherActive)
      return <React.Fragment />;

    return loginButton;
  };

  return (
    <header
      ref={refElement}
      className={
        `m-header${isModeOpen || isScrollActive ? " m-header-open" : ""}` +
        `${props.isMenuActive ? " m-header-open__menu" : ""}` +
        `${props.isSearcherActive ? " m-header-open__searcher" : ""}` +
        `${modeShadow ? " m-header-shadow" : ""}` +
        `${
          props.hideHeaderMobile && isScrollActive && props.lastDirection  > 0 && !isModeOpen
            ? " m-header__hide-mobile"
            : ""
        }` +
        `${
          props.hideHeaderDesktop &&
          !props.isMenuActive &&
          !props.isSearcherActive &&
          props.lastDirection > 0
            ? " m-header__hide-desktop"
            : ""
        }`
      }
    >
      {renderBurguerButton()}
      <div
        className={`m-header__container ${
          props.isSearcherActive && "m-header__container--search"
        }`}
        ref={refElement}
      >
        <div className="m-header__cover">
          <Link
            to="/"
            // rel="nofollow noreferrer"
            className="gtmMenuTransLogoComfama"
          >
            <img
              className="m-header__cover__img gtmMenuTransLogoComfama"
              src={
                (isModeOpen || modeShadow
                  ? props.isDark
                    ? logoMagenta
                    : logoGray
                  : logoWithe
                ).file.url
              }
              alt={
                (isModeOpen || modeShadow
                  ? props.isDark
                    ? logoMagenta
                    : logoGray
                  : logoWithe
                ).title
              }
            />
          </Link>
        </div>
        <div className="m-header__container-action">
          <i
            className="hide-mobile icon icon-font-change-2 gtmMenuTransTamanoLetra"
            onClick={() => setShowFontSize(!showFontSize)}
          />
          <div className={`float-box ${showFontSize ? "show" : ""}`}>
            {showFontSize && <FontSize setShowFontSize={setShowFontSize} />}
          </div>
          <i
            className={`hide-mobile icon ${
              props.isDark
                ? "icon-sun gtmMenuTransTonalidadFondoBlanco"
                : "icon-moon gtmMenuTransTonalidadFondoNegro"
            }`}
            onClick={props.actionTheme}
          />
          <i
            className={`icon ${
              props.isSearcherActive ? "icon-close" : "icon-search"
            } gtmMenuTransBuscar`}
            onClick={handleSearcher}
          />
          {renderLoginButton()}
        </div>
      </div>
    </header>
  );
};

export default Header;
